/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Audience_AmateurInputs */

const en_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amateur`)
};

const es_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aficionado`)
};

const de_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amateur`)
};

const zh_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`业余`)
};

const ar_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هاوٍ`)
};

const fr_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amateur`)
};

const vi_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nghiệp dư`)
};

const sw_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mchezaji wa ridhaa`)
};

const th_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มือสมัครเล่น`)
};

const bs_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amater`)
};

const ja_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アマチュア`)
};

const ko_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아마추어`)
};

const pt_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amador`)
};

const it_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amatore`)
};

const sv_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amatör`)
};

const nl_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amateur`)
};

const da_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amatør`)
};

const nb_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amatør`)
};

const fi_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amatööri`)
};

const pl_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amator`)
};

const ru_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Любитель`)
};

const tr_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amatör`)
};

const hi_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शौकिया`)
};

const id_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amatir`)
};

const ms_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amatur`)
};

const cs_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amatér`)
};

const el_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ερασιτέχνης`)
};

const he_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חובב`)
};

const af_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amateur`)
};

const hu_method_audience_amateur = /** @type {(inputs: Method_Audience_AmateurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amatőr`)
};

/**
* | output |
* | --- |
* | "Amateur" |
*
* @param {Method_Audience_AmateurInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_audience_amateur = /** @type {((inputs?: Method_Audience_AmateurInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Audience_AmateurInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_audience_amateur(inputs)
	if (locale === "de") return de_method_audience_amateur(inputs)
	if (locale === "zh") return zh_method_audience_amateur(inputs)
	if (locale === "ar") return ar_method_audience_amateur(inputs)
	if (locale === "fr") return fr_method_audience_amateur(inputs)
	if (locale === "vi") return vi_method_audience_amateur(inputs)
	if (locale === "sw") return sw_method_audience_amateur(inputs)
	if (locale === "th") return th_method_audience_amateur(inputs)
	if (locale === "bs") return bs_method_audience_amateur(inputs)
	if (locale === "ja") return ja_method_audience_amateur(inputs)
	if (locale === "ko") return ko_method_audience_amateur(inputs)
	if (locale === "pt") return pt_method_audience_amateur(inputs)
	if (locale === "it") return it_method_audience_amateur(inputs)
	if (locale === "sv") return sv_method_audience_amateur(inputs)
	if (locale === "nl") return nl_method_audience_amateur(inputs)
	if (locale === "da") return da_method_audience_amateur(inputs)
	if (locale === "nb") return nb_method_audience_amateur(inputs)
	if (locale === "fi") return fi_method_audience_amateur(inputs)
	if (locale === "pl") return pl_method_audience_amateur(inputs)
	if (locale === "ru") return ru_method_audience_amateur(inputs)
	if (locale === "tr") return tr_method_audience_amateur(inputs)
	if (locale === "hi") return hi_method_audience_amateur(inputs)
	if (locale === "id") return id_method_audience_amateur(inputs)
	if (locale === "ms") return ms_method_audience_amateur(inputs)
	if (locale === "cs") return cs_method_audience_amateur(inputs)
	if (locale === "el") return el_method_audience_amateur(inputs)
	if (locale === "he") return he_method_audience_amateur(inputs)
	if (locale === "af") return af_method_audience_amateur(inputs)
	if (locale === "hu") return hu_method_audience_amateur(inputs)
	return en_method_audience_amateur(inputs)
});